import 'whatwg-fetch';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { zIndex } from "@s7/styles";
import Footer from './Footer/Footer';
import { PortalHeader, fillProfileData } from '@s7ui-kit/s7ui-kit';
import { loadSettings } from '../../services/services/SettingsService';
import { isChromeBelow75 } from '../../services/utils/isChromeBelow75';
import { isStandalone } from '@s7/platform';
import qs from 'query-string';
import { FooterType } from "../../services/types/footer";
import { TabNavigation } from '../../fsd-structure/widgets/tab-navigation';
import HeaderWidget from '../../fsd-structure/widgets/header/ui/HeaderWidget';
import { Chat } from '../../fsd-structure/widgets/chat';

import '@s7ui-kit/s7ui-kit/build/style.css';

import SiteAlerts from "./SiteAlerts";
import MetaTagsHelmet from '../../components/common/MetaTagsHelmet';
import scrollPage from "../../services/utils/scrollPage";
import ModalUpdateBrowser from './ModalUpdateBrowser';
import Cookies from 'js-cookie';

import { analytics } from '../../services/analytics/analyticsManager';

let isFirstMount = true;

const mapStateToProps = state => ({
    lang: state.App.lang,
    oldLang: state.App.oldLanguage,
    supportedLanguages: state.App.supportedLanguages,
    deviceWidth: state.App.deviceWidth,
    pageInfo: state.PageInfo.pageInfo,
    profile: state.User.profile,
});

const mapDispatchToProps = dispatch => ({
    fillProfileData: (data) => {
        const actionResult = fillProfileData({ data });

        dispatch(actionResult);

        return dispatch(actionResult);
    },
});

window?.s7s?.on('cookie-policy', init => {
    init({
        offset: window.matchMedia('(min-width: 1272px)').matches ? 24 : 71,
        analytics,
    });
});

window?.s7s?.on('chat', init => {
    window.chat = init({ 
        application: window.matchMedia('(min-width: 767px)').matches ? 'portal_desktop' : 'portal_mobile_old',
        styles: {
            button: {
                zIndex: zIndex('app') + 1,
            },
        }, 
    });
})

const Layout = withRouter(connect(mapStateToProps, mapDispatchToProps)(class extends Component {
    state = {
        showHeader: true,
        showTabs: true,
        showFooter: true,
        isChatVisible: false,
        showCookiePolicy: true,
        showBrowserOld: false,
        isVKPage: false,
        visitedPortal: false,
        isProfi: false,
    };

    componentWillMount() {
        const { location } = this.props;
        const locationSearch = qs.parse(location.search);

        if ('mobile' in locationSearch) {
            this.setState({ showHeader: false, showFooter: false, showCookiePolicy: false, showTabs: false });
        }

        if ('vkpage' in locationSearch) {
            this.setState({ isVKPage: true, showFooter: false, showCookiePolicy: false });
        }

        if (window.location.pathname.indexOf('/info/routes/') !== -1 || window.location.pathname.indexOf('vkpage') !== -1) {
            this.setState({ showFooter: false });
        }
    }

    componentDidMount() {
        const { lang, location, history, supportedLanguages, oldLang, pageInfo } = this.props;

        const re = new RegExp(`^/(${supportedLanguages.join('|')})/`);
        const s7PageInit = typeof (window.s7PageInit) !== 'undefined' ? window.s7PageInit : {};
        const language = String(lang).replace(/(es|it|de)/g, 'en');
        const visitedPortal = Boolean(Number(Cookies.get('portal')))

        if (re.test(window.location.pathname) && supportedLanguages.length > 0) {
            const pathname = window.location.pathname.replace(re, `/${language}/`);
            history.push(`${pathname}${window.location.search}${window.location.hash}`);
        } else if (!isFirstMount && lang !== oldLang && supportedLanguages.includes(oldLang)) {
            history.push(`/${language}${location.pathname}${window.location.search}${window.location.hash}`);
        } else if (!re.test(window.location.pathname) && supportedLanguages.length > 0) {
            const pathname = window.location.pathname.replace(new RegExp(`^(/(es|it|de)/|/(es|it|de))`), `/en/`);
            history.push(`${pathname}${window.location.search}${window.location.hash}`);
        }

        isFirstMount = false;

        if (window.document.documentMode || isChromeBelow75()) {
            this.setState({ showBrowserOld: true });
        }

        this.props.history.listen(location => {
            try {
                if (window.ga) {
                    window.ga(
                        'create', process.env.NODE_BUILD_ENV === 'production' ? 'GTM-MWTMZW' : 'GTM-KRJNC2', 'auto'
                    );
                    const tracker = window.ga.getAll()[0];

                    tracker.send('pageview');
                }

                if (window.yaCounter4173733) window.yaCounter4173733.hit(location.pathname);
            } catch (e) {
                console.log(e);
            }
        });

        setTimeout(() => {
            if (document.querySelector('.page-content')) document.querySelector('.page-content').style.minHeight = 'initial';
        }, 5000);

        //глобально доскрол к Container по id по клику на элемент с href === hash
        document.body.addEventListener('click', (e) => {
            if (!!window.location.hash && e.target && e.target.href && e.target.href.indexOf(window.location.hash) !== -1) {
                e.preventDefault();
                if (document.querySelector(window.location.hash)) {
                    scrollPage(document.querySelector(window.location.hash));
                }
            }
        });

        this.checkChatValidation();

        if (s7PageInit?.page?.[s7PageInit?.pageLanguage]?.noTemplate
            || (pageInfo?.noTemplate)) {
            this.setState({ showHeader: false, showFooter: false, showCookiePolicy: false, showTabs: false });
        }

        this.setState({ visitedPortal });
    };

    componentWillReceiveProps = nextProps => {
        const { pageInfo } = this.props;
        if (nextProps.pageInfo && nextProps.pageInfo.noTemplate && pageInfo.noTemplate !== nextProps.pageInfo.noTemplate) {
            this.setState({ showHeader: false, showFooter: false, showCookiePolicy: false, showTabs: false });
        }
    };

    checkChatVisible = (chatData) => {
        let isExceptMatch = false;

        let exceptionUrls = window?.screen?.width > 767 ? chatData?.exceptionUrls || '' : chatData?.exceptionUrlsMobile || '';
        exceptionUrls = exceptionUrls.split('\r\n');
        exceptionUrls.forEach(url => {
            if (!!url && window.location.href.match(url)) {
                isExceptMatch = true;
            }

            if (url.includes('$') && window.location.href.includes(url.replace('$', ''))) {
                isExceptMatch = true;
            }
        })

        if (chatData?.profiChatForB2b !== false) this.setState({ isProfi: true });

        if (!isExceptMatch) this.setState({ isChatVisible: true});
    }

        checkChatValidation = () => {
        const s7PageInit = typeof (window.s7PageInit) !== 'undefined' ? window.s7PageInit : {};
        const { lang } = this.props;

        if (s7PageInit.settings) {
            if (s7PageInit.settings.chat && s7PageInit.settings.chat.enabled) {
                this.checkChatVisible(s7PageInit.settings.chat);
            }

        } else {
            loadSettings({ lang: lang, ns: 'default' }).then(response => {
                if (!response) {
                    return;
                }

                if (response.chat && response.chat.enabled) {
                    this.checkChatVisible(response.chat);
                }

            }).catch(error => console.log(error));
        }
    }

    render() {
        const { lang, allSupportedLanguages, children, deviceWidth } = this.props;
        const { showHeader, showFooter, showBrowserOld, isVKPage, showTabs } = this.state;
        
        const isProfi = this.state.isProfi;

        const mainPagExp = new RegExp(`^/(?:[a-z]{2}/?)?$`);

        return (
            <div className="App page">
                <Chat isChatVisible={this.state.isChatVisible} isProfi={isProfi} />
                <MetaTagsHelmet {...this.props} isMainPage={mainPagExp.test(window.location.pathname)} />
                {isVKPage && <div className={'vkpage__helper'}></div>}
                {/* Костыль, чтобы не ехала верстка, тк deviceWidth обновляется в PortalHeader */}
                <div style={{display: 'none'}}>
                    <PortalHeader />
                </div>
                {
                    showHeader && <HeaderWidget /> 
                }
                {!isVKPage && <SiteAlerts lang={lang} allSupportedLanguages={allSupportedLanguages} />}
                {showBrowserOld && !Cookies.get('isBrowserOld') && deviceWidth > 767 &&
                    <ModalUpdateBrowser />
                }
                <div className="page-content">
                    {children}
                </div>
                {showFooter && <Footer
                    code={isStandalone ? FooterType.WEBAPP : FooterType.DEFAULT}
                    clickChatButton={window.chat?.openChat}
                    lang={lang}
                    isMainPage={mainPagExp.test(window.location.pathname)}
                />}
                {showTabs && <TabNavigation />}
            </div>
        )
    }
}));

Layout.propTypes = {
    children: PropTypes.node,
    lang: PropTypes.string,
};

export default Layout;
